import { Fragment, useEffect, useState } from 'react';

const AIImageQulaitySelector = ({ selectName, onSelect, value = null, model = 'gpt-image-1', disabled = false }) => {
	const [ quality, setQuality ] = useState();

	useEffect(
		() => {
			if (value) {
				setQuality(value);
			} else {
				setQuality('medium');
			}
		},
		[ value ]
	);

	const handleQualitySelect = (e) => {
		setQuality(e.target.value);

		if (onSelect) {
			onSelect(e);
		}
	};

	return (
		<select
			className="form-select"
			name={selectName}
			value={quality}
			onChange={(e) => handleQualitySelect(e)}
			required
			disabled={disabled}
		>
			{model === 'gpt-image-1' ? (
				<Fragment>
					<option value="low">Low</option>
					<option value="medium">Medium</option>
					<option value="high">High</option>
					<option value="auto">Auto</option>
				</Fragment>
			) : (
				<Fragment>
					<option value="low">Low</option>
					<option value="medium">Medium</option>
					<option value="high">High</option>
					<option value="auto">Auto</option>
				</Fragment>
			)}
		</select>
	);
};

export default AIImageQulaitySelector;
